const value = {
    'global-allow-any': 'Access to anything',
    'is-have-access-to-projects': 'Access to projects',
    'project-in-team-read': 'Read projects access',
    'project-not-in-team-access': 'Access to projects without team',
    'project-not-in-team-permission-update-project': 'Access to update projects without team',
    'project-not-in-team-permission-update-team-project': 'Access to update project team without team',
    'project-not-in-team-permission-update-fields-project': 'Access to update project fields without team',
    'project-not-in-team-permission-create-project': 'Access to create projects without team',
    'project-not-in-team-permission-delete-project': 'Access to delete projects without team',
    'project-not-in-team-permission-create-application': 'Access to create systems without team',
    'project-not-in-team-permission-update-application': 'Access to update systems without team',
    'project-not-in-team-permission-delete-application': 'Access to delete systems without team',
    'project-not-in-team-permission-report-access': 'Access to reports in system without team',
    'project-not-in-team-permission-custom-requirement-access': 'Access to custom requirements without team',
    'project-not-in-team-permission-accept-cancel-access': 'Access to accept/cancel requirements without team',
    'project-not-in-team-permission-new-comments-access': 'Access to receive new comments without team',
    'settings-is-allow': 'Access to settings',
    'settings-specifications-delete': 'Access to delete specifications',
    'settings-specifications-create': 'Access to create specifications',
    'settings-specifications-update': 'Access to update specifications',
    'settings-specifications-read': 'Access to read specifications',
    'settings-requirements-delete': 'Access to delete requirements',
    'settings-requirements-create': 'Access to create requirements',
    'settings-requirements-update': 'Access to update requirements',
    'settings-requirements-read': 'Access to read requirements',
    'settings-requirement-vendors-delete': 'Access to delete vendor',
    'settings-requirement-vendors-create': 'Access to create vendor',
    'settings-requirement-vendors-update': 'Access to update vendor',
    'settings-requirement-vendors-read': 'Access to read vendor',
    'settings-tags-delete': 'Access to delete tags',
    'settings-tags-create': 'Access to create tags',
    'settings-tags-update': 'Access to update tags',
    'settings-tags-read': 'Access to read tags',
    'settings-statuses-delete': 'Access to delete statuses',
    'settings-statuses-create': 'Access to create statuses',
    'settings-statuses-update': 'Access to update statuses',
    'settings-statuses-read': 'Access to read statuses',
    'settings-performers-delete': 'Access to delete performer type',
    'settings-performers-create': 'Access to create performer type',
    'settings-performers-update': 'Access to update performer type',
    'settings-performers-read': 'Access to read performer type',
    'settings-additional-columns-delete': 'Access to delete additional columns',
    'settings-additional-columns-create': 'Access to create additional columns',
    'settings-additional-columns-update': 'Access to update additional columns',
    'settings-additional-columns-read': 'Access to read additional columns',
    'settings-integrations-delete': 'Access to delete integrations',
    'settings-integrations-create': 'Access to create integrations',
    'settings-integrations-update': 'Access to update integrations',
    'settings-integrations-read': 'Access to read integrations',
    'settings-application-template-delete': 'Access to delete system template',
    'settings-application-template-create': 'Access to create system template',
    'settings-application-template-update': 'Access to update system template',
    'settings-application-template-read': 'Access to read system template',
    'settings-user-entity-delete': 'Access to delete users',
    'settings-user-entity-create': 'Access to create users',
    'settings-user-entity-update': 'Access to update users',
    'settings-user-entity-read': 'Access to read users',
    'settings-user-project-role-delete': 'Access to delete project roles',
    'settings-user-project-role-create': 'Access to create project roles',
    'settings-user-project-role-update': 'Access to update project roles',
    'settings-user-project-role-read': 'Access to read project roles',
    'settings-user-system-role-delete': 'Access to delete system roles',
    'settings-user-system-role-create': 'Access to create system roles',
    'settings-user-system-role-update': 'Access to update system roles',
    'settings-user-system-role-read': 'Access to read system roles',
    'project-not-in-team-permission-jira-intergration': 'Access to AS integration with Jira',
    'project-not-in-team-permission-show-regulators': 'Access to viewing requirements of external regulators\n',
    'project-not-in-team-permission-show-unverified-requirements-access': 'Viewing unverified requirements',
    'settings-user-system-role-application-transfer': 'Ability to transfer/copy systems',
    addRoleModal: {
      noRestrictions: 'No restrictions',
      accessToTheProjectsSection: 'Access to the Projects section',
      accessInProjectsWithoutAnyProjectRole: 'Access in projects without any project role',
      rightsInProjectsWithoutAnyProjectRole: 'Rights in projects without any project role',
      itIsPossibleToTransferOrCopySystems: 'It is possible to transfer/copy systems',
      notificationSettings: 'Notification settings',
      accessToSettingsIsAvailable: 'Access to settings is available',
      settingsFeaturesOfAS: 'Settings - Features of AS',
      settingsTemplatesOfRequirements: 'Settings - Templates of requirements',
      settingsRequirementsOfExternalRegulatoryAuthorities: 'Settings - Requirements of external regulatory authorities',
      settingsTagsForRequirements: 'Settings - Tags for requirements',
      settingsStatuses: 'Settings - Statuses',
      settingsExecutorsOfRequirements: 'Settings - Executors of requirements',
      settingsAdditionalColumns: 'Settings - Additional columns',
      settingsIntegrations: 'Settings - Integrations',
      settingsUsers: 'Settings - Users',
      settingsSystemRoles: 'Settings - System roles',
      settingsProjectRoles: 'Settings - Project roles',
      settingsTemplatesOfProfiles: 'Settings - Templates of profiles',
      logging: 'Logging',
      riskProfile: 'Risk profile',
      creatingProjects: 'Creating projects',
      editingProjectTeams: 'Editing project teams',
      editingProjectFields: 'Editing project fields',
      deletingProjects: 'Deleting projects',
      creatingSystems: 'Creating systems',
      updatingSystems: 'Updating systems',
      deletingSystems: 'Deleting systems',
      accessToReports: 'Access to reports',
      viewingUnverifiedRequirements: 'Viewing unverified requirements',
      accessToCreatingOrEditingLocalRequirements: 'Access to creating/editing local requirements',
      acceptingOrCancelingRequirements: 'Accepting/canceling requirements',
      viewingRequirementsOfExternalRegulatoryAuthorities: 'Viewing requirements of external regulatory authorities',
      integratingAsWithJira: 'Integrating AS with Jira',
      settingTheRequirementsVerificationFlagWhenCreatingASystem:
        'Setting the requirements verification flag when creating a system',
      terminatingAcceptanceTests: 'Terminating acceptance tests',
      notificationAboutChangingAllStatusesForRequirementsToOneOfTheAvailableValues:
        'Notification about changing all Statuses for requirements to one of the available values',
      creatingANewProjectOrChangingTheCurrentProject: 'Creating a new project / Changing the current project',
      creatingANewAsProfileInTheProject: 'Creating a new AS Profile in the Project',
      changingAnExistingAsProfileInTheProject: 'Changing an existing AS Profile in the Project',
      transferringAnAsProfileToAnotherProject: 'Transferring an AS Profile to another Project',
      copyingAnAsProfileToAnotherProject: 'Copying an AS Profile to another Project',
      updatingTheAsRequirementsSetAfterChangingTheRequirementsTemplates:
        'Updating the AS requirements set after changing the requirements templates',
      creatingANewRequirementsTemplate: 'Creating a new Requirements Template',
      updatingARequirementsTemplate: 'Updating a Requirements Template',
      deletingARequirementsTemplate: 'Deleting a Requirements Template',
    },
  };

export default value;
